<template>
  <b-link :href="href" :target="target" :rel="rel">
    <slot/>
    <i class="fas fa-external-link-alt p-down"></i>
  </b-link>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      required: true,
    },
    target: {
      type: String,
      default: () => {
        return "_blank"
      }
    },
    rel: {
      type: String,
      default: () => {
        return "noopener noreferrer"
      }
    },
  },
}
</script>
